import { memo } from 'react';
import { TableHeaderCell as TH } from 'foundations-components/transitional/components/Table';
import { NUMERIC_PROPERTIES } from 'reporting-data/constants/numericProperties';
import { Text } from 'foundations-components/components/Text';
import { getCellBlockSize, convertToTextAlign } from '../tableUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const StandardText = ({
  label
}) => {
  if (!label) return undefined;
  return /*#__PURE__*/_jsx(Text, {
    typography: 'heading-50',
    children: label
  });
};
const MobileText = ({
  label
}) => {
  if (!label) return undefined;
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx("span", {
      style: {
        fontSize: '10px'
      },
      children: label
    })
  );
};
const defaultRenderFooterCell = args => {
  const {
    column: {
      align,
      dataset,
      field,
      index,
      showAsBarChart
    },
    footer: {
      label
    },
    isMobile
  } = args;
  const columnType = dataset.getIn(['properties', field, 'type']);
  const thLabel = (index === 0 || NUMERIC_PROPERTIES.includes(columnType)) && label;
  return /*#__PURE__*/_jsx(TH, {
    blockSize: getCellBlockSize(isMobile),
    textAlign: convertToTextAlign(align)
    // @ts-expect-error - colSpan is an attribute on HTML th, but not an explicit param of SortTH
    ,
    colSpan: showAsBarChart ? 2 : 1,
    children: isMobile ? /*#__PURE__*/_jsx(MobileText, {
      label: thLabel
    }) : /*#__PURE__*/_jsx(StandardText, {
      label: thLabel
    })
  });
};
const TableFooterCell = ({
  column,
  isMobile
}) => {
  const {
    footer,
    renderFooterCell
  } = column;
  const renderArgs = {
    column,
    footer,
    isMobile
  };
  const defaultRender = () => defaultRenderFooterCell(renderArgs);
  return renderFooterCell ? renderFooterCell(Object.assign({
    defaultRender
  }, renderArgs)) : defaultRender();
};
export default /*#__PURE__*/memo(TableFooterCell);